import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
	exportMasterData(data) {

		let url = config.api.baseUrl + '/api/reports/export/masterData'

		return HTTP
			.request()
			.post(url, data, {
				responseType: 'arraybuffer'
			})
			.then(response => response)
			.catch(error => error)
	},
	exportSDA(data) {

		let url = config.api.baseUrl + '/api/reports/export/sda'

		return HTTP
			.request()
			.post(url, data, {
				responseType: 'arraybuffer'
			})
			.then(response => response)
			.catch(error => error)

	},
	exportPotential(data) {

		let url = config.api.baseUrl + '/api/reports/export/potential'

		return HTTP
			.request()
			.post(url, data, {
				responseType: 'arraybuffer'
			})
			.then(response => response)
			.catch(error => error)

	},
	exportCCI(data) {

		let url = config.api.baseUrl + '/api/reports/export/cci'

		return HTTP
			.request()
			.post(url, data, {
				responseType: 'arraybuffer'
			})
			.then(response => response)
			.catch(error => error)

	},
	exportEducation(data) {

		let url = config.api.baseUrl + '/api/reports/export/education'

		return HTTP
			.request()
			.post(url, data, {
				responseType: 'arraybuffer'
			})
			.then(response => response)
			.catch(error => error)

	}
}



// WEBPACK FOOTER //
// ./src/api/reports.js